/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgLockFill = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M17 8h2.5S21 8 21 9.5v10s0 1.5-1.5 1.5h-15C3 21 3 19.5 3 19.5v-10C3 8 4.5 8 4.5 8H7c0-6 5-6 5-6s5 0 5 6m-1.5 0c0-4.5-3.5-4.5-3.5-4.5S8.5 3.5 8.5 8zM12 16.375s2 0 2-2-2-2-2-2-2 0-2 2 2 2 2 2" clipRule="evenodd" /></svg>;
export default SvgLockFill;